import { aosRefresh } from '../../../../../global/js/core/core';

/**
 * Handles the interactive behavior of the product breakdown module.
 * Toggles the visibility of a collapsible table when the header is clicked.
 */
function productBreakdownA1() {
    /**
     * Initializes the product breakdown table interactions.
     * @param {HTMLElement} block - The container element for the product breakdown module.
     */
    function init(block) {
        const tables = block.querySelectorAll('.js-table');
        if (!tables.length) {
            return;
        }

        tables.forEach((table) => {
            const header = table.querySelector('.js-header');
            const bodyInner = table.querySelector('.js-body-inner');

            if (!header || !bodyInner) {
                return;
            }

            header.addEventListener('click', (event) => {
                event.preventDefault();

                const isOpened = table.dataset.active === '1';
                table.classList.toggle('active', !isOpened);
                jQuery(bodyInner)[isOpened ? 'slideDown' : 'slideUp']();
                table.setAttribute('data-active', isOpened ? '0' : '1');
                aosRefresh();
            });
        });
    }

    // Select all modules and initialize them
    document
        .querySelectorAll(`[data-module='productBreakdownA1']`)
        .forEach(init);
}

export default productBreakdownA1;
